import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function AboutPage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section className="pt-24 pb-16 bg-gradient-to-br from-black via-gray-900 to-black">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-5xl sm:text-6xl font-bold text-white mb-6">
              À Propos de
              <span className="block text-transparent bg-clip-text bg-gradient-to-r from-[#FF6B35] to-[#FF8A65]">
                VYBE PARIS
              </span>
            </h1>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed">
              Une maison créative parisienne qui redéfinit les codes du luxe moderne
            </p>
          </div>
        </div>
      </section>

      {/* Story Section */}
      <section className="py-20 bg-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div>
              <h2 className="text-4xl font-bold text-black mb-8">
                Notre Histoire
              </h2>
              <div className="w-24 h-1 bg-gradient-to-r from-[#FF6B35] to-[#FF8A65] mb-8"></div>
              <p className="text-lg text-gray-700 leading-relaxed mb-6">
                VYBE PARIS est née d'une vision audacieuse : créer un pont entre le luxe traditionnel 
                et l'innovation digitale moderne. Fondée au cœur de Paris, notre maison créative puise son 
                inspiration dans l'énergie urbaine de la capitale française.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed mb-6">
                Chaque création reflète notre philosophie : allier la force mythologique à 
                l'élégance parisienne, pour donner naissance à des pièces uniques qui transcendent 
                les codes du streetwear traditionnel.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed">
                Notre approche révolutionnaire combine artisanat d'exception, design visionnaire 
                et technologies de pointe pour créer des expériences luxueuses authentiques.
              </p>
            </div>
            <div className="relative">
              <img 
                src="https://public.readdy.ai/ai/img_res/fed5c7bd666f8dd8cd6d3fd7a92ba44a.jpg"
                alt="Atelier VYBE PARIS"
                className="w-full h-96 object-cover rounded-2xl shadow-2xl"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent rounded-2xl"></div>
            </div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-black mb-6">
              Nos Valeurs
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-[#FF6B35] to-[#FF8A65] mx-auto mb-8"></div>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Les piliers qui guident chacune de nos créations
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            <div className="text-center p-8 bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300">
              <div className="w-20 h-20 mx-auto mb-6 bg-gradient-to-br from-[#FF6B35] to-[#FF8A65] rounded-full flex items-center justify-center">
                <i className="ri-flashlight-line text-3xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-black mb-4">Innovation</h3>
              <p className="text-gray-600 leading-relaxed">
                Nous repoussons constamment les limites du design et de la technologie 
                pour créer des expériences uniques et avant-gardistes.
              </p>
            </div>

            <div className="text-center p-8 bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300">
              <div className="w-20 h-20 mx-auto mb-6 bg-gradient-to-br from-[#FF6B35] to-[#FF8A65] rounded-full flex items-center justify-center">
                <i className="ri-award-line text-3xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-black mb-4">Excellence</h3>
              <p className="text-gray-600 leading-relaxed">
                Chaque détail compte. Nous nous engageons à livrer une qualité 
                irréprochable dans tous nos projets et créations.
              </p>
            </div>

            <div className="text-center p-8 bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300">
              <div className="w-20 h-20 mx-auto mb-6 bg-gradient-to-br from-[#FF6B35] to-[#FF8A65] rounded-full flex items-center justify-center">
                <i className="ri-heart-line text-3xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-black mb-4">Authenticité</h3>
              <p className="text-gray-600 leading-relaxed">
                Nous restons fidèles à notre vision créative tout en respectant 
                l'héritage culturel et artistique qui nous inspire.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section className="py-20 bg-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-black mb-6">
              L'Équipe Créative
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-[#FF6B35] to-[#FF8A65] mx-auto mb-8"></div>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Des talents passionnés qui donnent vie à notre vision
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
            <div className="text-center group">
              <div className="relative mb-6">
                <img 
                  src="https://static.readdy.ai/image/445bd39afde876450f502e12e8cf89e5/ea054f6d7ebad684b2ecfb10951ea455.jpeg"
                  alt="Directeur Créatif"
                  className="w-48 h-48 mx-auto object-cover rounded-full shadow-lg group-hover:shadow-xl transition-all duration-300"
                />
              </div>
              <h3 className="text-xl font-bold text-black mb-2">Adel Saï</h3>
              <p className="text-[#FF6B35] font-semibold mb-3">Directeur Créatif</p>
              <p className="text-gray-600 text-sm">
                Visionnaire du design et architecte de l'identité VYBE PARIS
              </p>
            </div>

            <div className="text-center group">
              <div className="relative mb-6">
                <img 
                  src="https://static.readdy.ai/image/445bd39afde876450f502e12e8cf89e5/7fd171528b251b6864c8e38f6b7fc2c9.jpeg"
                  alt="Directeur Artistique"
                  className="w-48 h-48 mx-auto object-cover rounded-full shadow-lg group-hover:shadow-xl transition-all duration-300"
                />
              </div>
              <h3 className="text-xl font-bold text-black mb-2">Adel Saï</h3>
              <p className="text-[#FF6B35] font-semibold mb-3">Directeur Artistique</p>
              <p className="text-gray-600 text-sm">
                Expert en tendances et créateur d'expériences visuelles uniques
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-black via-gray-900 to-black">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold text-white mb-6">
            Rejoignez l'Univers VYBE PARIS
          </h2>
          <p className="text-xl text-gray-300 mb-10 leading-relaxed">
            Découvrez nos créations exclusives et faites partie de cette révolution du luxe moderne
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/boutique"
              className="inline-block bg-gradient-to-r from-[#FF6B35] to-[#FF8A65] text-white font-bold px-8 py-4 rounded-full hover:shadow-lg transform hover:scale-105 transition-all duration-300"
            >
              Découvrir la Boutique
            </Link>
            <Link
              to="/contact"
              className="inline-block bg-transparent border-2 border-white text-white font-bold px-8 py-4 rounded-full hover:bg-white hover:text-black transition-all duration-300"
            >
              Nous Contacter
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
